export const NAME = 'appointmentUserFiles';